import { UserNotificationsNotifications } from "@microtica/ms-notification-sdk";
import { Project } from "@microtica/ms-project-sdk";
import { Button, Drawer } from "antd";
import { useState } from "react";
import { useRecoilState } from "recoil";
import { getNotificationService, getProjectService } from "../../backend";
import { currentProjectState } from "../../recoil/project";
import { setProjectLocalStorage } from "../../utils/local-storage";
import Notification from "./Notification";

interface NotificationsDrawerProps {
    projects: Project[],
    notifications: UserNotificationsNotifications[],
    visible?: boolean;
    onClose: () => void;
}

const NotificationsDrawer = ({
    projects,
    notifications,
    visible,
    onClose
}: NotificationsDrawerProps) => {
    const [currentProject, setCurrentProject] = useRecoilState(currentProjectState);
    const [showOnlyUnreadNotifications, setShowOnlyUnreadNotifications] = useState<boolean>(false);

    const updateProjectInfo = async (projectId: string) => {
        const { data: project } = await getProjectService().getProject(projectId);
        setProjectLocalStorage(project);
        setCurrentProject(project!);
    }

    const toggleShowOnlyUnreadNotifications = (value: boolean) => {
        setShowOnlyUnreadNotifications(value);
    }

    const handleMarkAllNotificationsAsRead = async () => {
        await getNotificationService().markNotificationsAsRead(currentProject.id);
        onClose();
    }

    return (
        <Drawer
            title="Notifications"
            placement="right"
            open={visible}
            destroyOnClose={true}
            closable={true}
            onClose={onClose}
        >
            {
                <>
                    <div style={{ marginBottom: 5 }}>
                        <Button type="text" size="small" onClick={() => toggleShowOnlyUnreadNotifications(false)}>
                            All
                        </Button>
                        |
                        <Button type="text" size="small" onClick={() => toggleShowOnlyUnreadNotifications(true)}>
                            Unread
                        </Button>
                        <Button type="text" size="small" style={{ float: "right" }} onClick={handleMarkAllNotificationsAsRead}>
                            Mark all as read
                        </Button>
                    </div>
                    {
                        notifications
                            .filter(notification => showOnlyUnreadNotifications ? !notification.isRead : true)
                            .map(notification => (
                                <Notification
                                    {...notification}
                                    key={notification.id}
                                    projectName={projects.find(p => p.id === notification.projectId)?.name!}
                                    onClose={onClose}
                                    updateProjectInfo={updateProjectInfo}
                                />
                            ))
                    }
                </>
            }
        </Drawer>
    )
}

export default NotificationsDrawer;